import { FormattedMessage } from "react-intl";

import { REPO_HOME_PAGE_URL } from "../../constants";

import { TiCloudStorage } from "react-icons/ti";


export const repoUserLinks = [
    {
        title: <FormattedMessage id="repository" defaultMessage={"Repository"} />,
        icon: TiCloudStorage,
        to: REPO_HOME_PAGE_URL
    },

]